export default "__VITE_ASSET__B8$NUid8__"